<template>
    <div class="m-view__gift">
        <h5 class="title"></h5>
        <div class="slogen">
            <p>单人或结义小队模式下，均可消耗结义值在对应库中</p>
            <p>自由组合6个游戏道具进行打包兑换</p>
        </div>

        <div class="token-info flex-center-center">
            <div class="info flex-center-center">当前累计拥有： <div class="cnt">{{ $store.state.userinfo.zid && score_info.score ? score_info.score : 0  }}  <em class="icon-token sprite sprite-icon-token"></em></div></div>
            <div class="u-btn add sprite sprite-btn-add" @click="$router.push({ name: 'team',});"></div>
        </div>

        <div class="box-view">
            <div class="box-wrapper flex-start-start flex-wrap">
                <div class="box-item" :class="{'dismiss' : rewardClaimed }" v-for="(item,index) in basket" :key="index">
                    <div class="goods-detail">
                        <div class="goods-wrapper">
                            <div class="goods-pic" v-tips="item.giftId"><game-item :locked="true" :id="item.giftId" :num="item.sendNum"></game-item></div>
                        </div>                                 
                    </div>
                    <div class="u-btn del sprite sprite-btn-del" @click="basket_del(item)" v-if="!rewardClaimed"></div>                  
                </div>
                <div class="box-item box-temp" v-for="n in 6 - basket.length" :key="'box-' + n"></div>
            </div>

            <div class="total-token u-btn submit sprite sprite-btn-cost" @click="pack_apply()" v-if="!rewardClaimed ">
                {{ sum }}<em class="icon-token sprite sprite-icon-token"></em>
            </div>
            <div class="total-token u-btn submit dismiss  sprite sprite-btn-dismiss" v-else>已领取</div>

        </div>



        <div class="notice">
            <div class="sprite sprite-icon-notice"></div>
            从下方3个自选库<b>选满6个奖励</b>，选择后<b>自动计算兑换总价</b>每个用户<b>仅可兑换一次</b>，建议选择高品质道具兑换
        </div>

        <div class="store-view">
            <div class="store-title"></div>

            <div class="pannel-view">
                <div class="tab-hd flex-between-center">
                    <div class="tab-btn t-1" @click="active = 0" :class="{'act' : active == 0}"></div>
                    <div class="tab-btn t-2" @click="active = 1" :class="{'act' : active == 1,'locked' : $store.state.team.member && $store.state.team.member.length < 2}"></div>
                    <div class="tab-btn t-3" @click="active = 2" :class="{'act' : active == 2,'locked' : $store.state.team.member && $store.state.team.member.length < 3}"></div>
                </div>

                <div class="tab-bd">
                    <div class="store-list" v-show="active == 0">
                        <div class="notice">本自选库可选<b>2-6个奖励</b></div>
                        <div class="list-view flex-center-start flex-wrap">
                            <div class="list-item" v-for="(item,index) in list['1']" :key="index">
                                <div class="item-name"><p class="text-overflow-2">{{ item.giftName }}</p></div> 

                                <div class="goods-detail">
                                    <div class="goods-wrapper">
                                        <div class="goods-pic" v-tips="item.giftId"><game-item :locked="true" :id="item.giftId" :num="item.sendNum"></game-item></div>
                                    </div>                                 
                                </div>
                                
                                <div class="price">{{ item.amt }}<em class="icon-token sprite sprite-icon-token"></em></div>

                                <div class="u-btn submit sprite sprite-btn-shop" v-if="!item.inBasket" @click="basket_add(item,1)"></div>
                                <div class="u-btn dismiss sprite sprite-status-disabled" v-else></div>
                            </div>
                        </div>
                    </div>
                    <div class="store-list" v-show="active == 1">
                        <div class="notice">在【结义返利】中<b>完成2人组队</b>开启，本库可选<b>0-2个奖励</b></div>

                        <div class="list-view flex-center-start flex-wrap">
                            <div class="list-item" v-for="(item,index) in list['2']" :key="index">
                                <div class="item-name"><p class="text-overflow-2">{{ item.giftName }}</p></div> 

                                <div class="goods-detail">
                                    <div class="goods-wrapper">
                                        <div class="goods-pic" v-tips="item.giftId"><game-item :locked="true" :id="item.giftId" :num="item.sendNum"></game-item></div>
                                    </div>                                 
                                </div>
                                
                                <div class="price">{{ item.amt }}<em class="icon-token sprite sprite-icon-token"></em></div>

                                <div class="u-btn submit sprite sprite-btn-shop" v-if="!item.inBasket" @click="basket_add(item,2)"></div>
                                <div class="u-btn dismiss sprite sprite-status-disabled" v-else></div>
                            </div>                        
                        </div>
                    </div>
                    <div class="store-list" v-show="active == 2">
                        <div class="notice">在【结义返利】中<b>完成3人组队</b>开启，本库可选<b>0-2个奖励</b></div>

                        <div class="list-view flex-center-start flex-wrap">
                            <div class="list-item" v-for="(item,index) in list['3']" :key="index">
                                <div class="item-name"><p class="text-overflow-2">{{ item.giftName }}</p></div> 

                                <div class="goods-detail">
                                    <div class="goods-wrapper">
                                        <div class="goods-pic" v-tips="item.giftId"><game-item :locked="true" :id="item.giftId" :num="item.sendNum"></game-item></div>
                                    </div>                                 
                                </div>
                                
                                <div class="price">{{ item.amt }}<em class="icon-token sprite sprite-icon-token"></em></div>

                                <div class="u-btn submit sprite sprite-btn-shop" v-if="!item.inBasket" @click="basket_add(item,3)"></div>
                                <div class="u-btn dismiss sprite sprite-status-disabled" v-else></div>
                            </div>                        
                        </div>
                    </div>
                </div>
            </div>


        </div>

        <!-- <div class="u-btn"></div> -->
    </div>
</template>

<style lang="scss" scoped>
.title{
    width: 581px;
    height: 170px;
    margin: 0 auto;
    background-image: url(~@/assets/images/title-2.png);   
}

.slogen{
    color: #ecb785;
    text-align: center;
}

.token-info{
    margin-top: 20px;
    margin-bottom: 35px;
    font-size: 28px;
    color: #63372a;
    text-align: center;

    .info{
        width: 362px;
        height: 72px;
        line-height: 37px;
        text-align: center;
        color: #fcd583;
        font-size: 24px;
        font-weight: 700;
        background-image: url(~@/assets/images/bg-score-info.png);         
    }

    .u-btn.add{
        margin-left: 10px;
    }
}

.box-view{
    width: 681px;
    height: 525px;
    margin: 0 auto;
    padding-top: 104px;
    background-image: url(~@/assets/images/pannel-select.png);

    .box-wrapper{
        width: 594px;
        height: 280px;
        margin: 0 auto;
        padding: 0 78px;
        box-sizing: border-box;
    }

    .box-item{
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 106px;
        height: 105px;
        margin: 0 20px 25px;
        background-image: url(~@/assets/images/bg-item_2.png);

        &.dismiss{
            // .goods-wrapper::after{
            //     content: '';
            //     display: block;
            //     position: absolute;
            //     left: 50%;
            //     top: 50%;
            //     transform: translate(-50%,-50%);
            //     width: 68px;
            //     height: 68px;
            //     background-image: url(~@/assets/images/icon-dismiss.png);
            //     background-repeat: no-repeat;
            //     background-position: center center;
            // }              
        }
    }



    .u-btn.del{
        position: absolute;
        right: -9.5px;
        top: -9.5px;
    }
}

.total-token{
    line-height: 134px;
    text-align: center;
    margin: -5px auto 0;
    // background-image: url(~@/assets/images/btn-token.png);
    font-size: 32px;
    color: #8c421f;
}

.notice{
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin-top: 30px;
    padding: 0 75px;
    font-size: 20px;
    color: #ed9f71;

    b{
        font-weight: 400;
        color: #ca3113;
    }

}

.store-view{
    margin-top: 60px;

    .store-title{
        width: 557px;
        height: 53px;
        margin: 0 auto 30px;
        background-image: url(~@/assets/images/slogen-box.png);
    }

    .pannel-view{
        position: relative;
        width: 750px;
        height: 1376px;
        margin: 0 auto;
        padding-top: 34px;
        background-image: url(~@/assets/images/pannel-select_list.png);
    }

    .notice{
        margin-bottom: 20px;
        font-size: 24px;
        color: #e49f59;
    }

    .tab-hd{
        padding: 0 20px;

        .tab-btn{
            position: relative;
            width: 230px;
            height: 76px;
            cursor: pointer;


            @for $i from 1 through 3{
                &.t-#{$i}{
                    background-image: url(~@/assets/images/box/#{$i}.png);

                    &.locked{
                        background-image: url(~@/assets/images/box/#{$i}-locked.png); 
                    }
                    
                    &.act{
                        background-image: url(~@/assets/images/box/#{$i}D.png); 
                    }
                    
                    &.locked.act{
                        background-image: url(~@/assets/images/box/#{$i}D-locked.png); 
                    }
                }
            }              
        }
    }

    .notice{
        padding: 0;
        text-align: center;
    }

    .list-item{
        position: relative;
        width: 160px;
        height: 330px;
        margin: 0 8px 25px;
        padding-top: 20px;
        background-image: url(~@/assets/images/item-select.png);
    }

    .goods-detail{
        display: flex;
        align-items: center;
        justify-content: center;
        width: 82px;
        height: 82px;
        margin: 0 auto 25px;
        background-image: url(~@/assets/images/bg-item_3.png);       
    }

    .item-name{
        position: relative;        
        margin-bottom: 36px;
        padding: 0 14px 0;

        p{
            height: 2.4em;
            color: #9b4e0a;
            text-align: center;
        }

        &::after{
            content: '';
            display: block;
            position: absolute;
            left: 50%;
            bottom: -24px;
            width: 144px;
            height: 14px;
            transform: translateX(-50%);
            background-image: url(~@/assets/images/item-name.png);
        }
    }

    .price{
        margin-bottom: 8px;
        text-align: center;
        font-size: 24px;
        color: #4e2612;
    }

    .icon-token{
        display: inline-block;
        vertical-align: middle;
    }

    .u-btn.submit{
        margin: 16px auto 0;
    }

    .u-btn.dismiss{
        margin: 16px auto 0;
        //background-image: url(~@/assets/images/btn-submit.png);
    }    
}

.u-btn.apply{
    margin: 55px auto 0;
    //background-image: url(~@/assets/images/btn-apply.png);
}
</style>

<script>
import { apiBoxList,apiPackApply,apiBoxInfo,apiScoreInfo } from '@/api/index';
export default {
    data (){
        return {
            list : { '1' : [] , '2' : [] , '3' : []},
            active : 0,
            basket : [],
            sum : 0,
            rewardClaimed : false,
            score_info : {},
        }
    },
    mounted(){
        this.box_list();
        this.render();
    },
    computed : {
        render_flag(){
            return this.$store.state.flag;
        }
    },
    watch : {
        basket : {
            handler(newVal, oldVal) {
               this.sum_amt();                  
            },
            deep: true
        },
        render_flag : {
            handler(newVal, oldVal) {
               this.render();                
            },
        }                 
    },     
    methods : {
        render(){
            if(this.$store.state.userinfo.zid){
                apiBoxInfo().then(
                    res => {
                        this.basket = res.data.giftList || [];
                        this.rewardClaimed = res.data.rewardClaimed;
                    },
                )

                apiScoreInfo().then(
                    res => {
                        res.data.length ? this.score_info = res.data[0] : {};
                    },
                )
            }
        },
        box_list (){
            apiBoxList({typeId : 2}).then(
                res => {
                    this.list['1'] = res.data.filter((ele)=>{ return ele.groupId == 1 });
                    this.list['2'] = res.data.filter((ele)=>{ return ele.groupId == 2 });
                    this.list['3'] = res.data.filter((ele)=>{ return ele.groupId == 3 });
                },
                rej => {}
            );
        },
        basket_add(item,type){
            let config = { '1' : {max : 6 , min : 2 , member : 0}, '2' : {max : 2 , min : 0 , member : 2}, '3' : {max : 2 , min : 0 , member : 3}};
            let max = config[type].max;
            let member = config[type].member;
            let arr_type = this.basket.filter((ele)=>{ return ele.groupId == type });
            //todo
            if(this.rewardClaimed){
                return this.$toast('奖励已发放至军师邮箱或网页活动，请及时领取');
            }
            else if(this.basket.length == 6){
                return this.$toast('【结义福泽箱】选择道具已达上限');
            }
            else if(arr_type.length == max){
                return this.$toast('此自选库选择道具已达上限，请前往其他库进行选择');
            }
            else if(this.$store.state.team.member.length < member){
                return this.$toast('请先在【结义返利】中完成'+ member +'人结义组队');
            }            

            item.inBasket = true;

            this.basket.push(item);
        },
        basket_del(item){
            item.inBasket = false;
            let newArray = this.basket.filter((val,index) => val.id != item.id);
            this.basket = newArray;
        },
        sum_amt(){
            var s = 0;
            this.basket.forEach(function(val) {
                s += val.amt;
            }, 0);

            this.sum = s;
        },
        pack_apply(){
            if(!this.$store.state.userinfo.uid){
                return this.$mslogin.login();
            }

            if(!this.$store.state.userinfo.zid){
                this.$toast('请绑定大区');
                return this.$bind_modal();
            }

            if(this.basket.length != 6){
                return this.$toast('请先选择6个游戏道具');
            }

            this.$comfirm_modal({ basket : this.basket })
        },
    }
}
</script>
